import {
    Button,
    ContextMenu,
    defaultIconSize,
    FlexColumn,
    TableToolbarButton,
} from '@synqo/frontend-component-library';
import { IconTableExport } from '@tabler/icons-react';

interface BaseExportOption {
    id: string;
    display_string: string;
}

export interface ExportOptionsMenuProps<T extends BaseExportOption> {
    exportOptions: T[];
    setCurrentExportOption: (exportOption: T | undefined) => void;
    hasExportOptions: boolean;
    exportDisabled?: boolean;
}

export const ExportOptionsMenu = <T extends BaseExportOption>({
    exportOptions,
    setCurrentExportOption,
    hasExportOptions,
    exportDisabled = false,
}: ExportOptionsMenuProps<T>) => {
    if (!hasExportOptions) {
        return undefined;
    }

    if (exportOptions.length === 1) {
        const option = exportOptions[0];
        return (
            <TableToolbarButton
                key={option.id}
                onClick={() => setCurrentExportOption(option)}
                locked={exportDisabled}
                label={option.display_string}
                tooltip={option.display_string}
                icon={IconTableExport}
            />
        );
    } else {
        return (
            <ContextMenu
                key="ctx_export_option"
                icon={IconTableExport}
                name="export_options"
                tooltip="Export"
                variant="subtle"
                textColor="grey"
                buttonSize="lg"
                locked={exportDisabled}
            >
                <FlexColumn justify="start" align="stretch">
                    {exportOptions.map((option) => (
                        <Button
                            key={option.id}
                            appearance="filled"
                            onClick={() => setCurrentExportOption(option)}
                            locked={exportDisabled}
                        >
                            <IconTableExport size={defaultIconSize} />
                            &nbsp;{option.display_string}
                        </Button>
                    ))}
                </FlexColumn>
            </ContextMenu>
        );
    }
};
